import { Component, OnInit } from '@angular/core';
import { OpenAiService } from 'src/app/services/openai.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss'],
  standalone: true,
  imports: [FormsModule, CommonModule, TranslateModule]
})
export class AiChatComponent implements OnInit {
  prompt = '';
  chatHistory: { role: string, content: string }[] = [];

  constructor(private ai: OpenAiService,  private translate: TranslateService) {}

ngOnInit() {
  this.translate.get('CHATBOT.WELCOME').subscribe(translated => {
    this.chatHistory.push({
      role: 'assistant',
      content: translated
    });
  });
}

  send() {
    if (this.prompt.trim() === '') return;

    // User Message hinzufügen
    this.chatHistory.push({ role: 'user', content: this.prompt });

    // Anfrage an den Service senden
    this.ai.chat(this.prompt).subscribe({
      next: res => {
        const message = res?.choices?.[0]?.message?.content ?? 'Fehler';
        this.chatHistory.push({ role: 'assistant', content: message }); // Antwort von GPT
        this.prompt = ''; // Eingabefeld leeren
      },
      error: err => {
        this.chatHistory.push({ role: 'assistant', content: '❌ Fehler bei Anfrage' });
        this.prompt = ''; // Eingabefeld leeren
      }
    });
  }

  setPrompt(key: string) {
    this.translate.get(key).subscribe(translated => {
      this.prompt = translated;
    });
}
}
